import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLegacies,
  resetLegaciesState,
} from "../../../../../../redux/slices/legacySlice";
import { handleErrorRedirect } from "../../../../../../utility/errorRedirect";
import { useNavigate } from "react-router-dom";
import {
  FormActions,
  FormDropdown,
} from "../../../../../../components/Stepper/fields/inputField";
import { updatelegacyNameService } from "../../../../../../services/transaction";
import { FaTimes } from "react-icons/fa";
import {
  formatNumber,
  truncateToTwoDecimals,
} from "../../../../../../utility/helper";
const LegacyComponent = ({
  legaciesData,
  selectedAsset,
  GetLegaciesData,
  toast,
}) => {
  const data = legaciesData?.data;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLegacy, setSelectedLegacy] = useState(null);
  const [updatedLegacy, setUpdatedLegacy] = useState("");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));

  const [loading, setLoading] = useState(false);

  const { legaciesData: legaciesDataOption, legacyLoading } = useSelector(
    (state) => state.legacies
  );
  const { currency } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchLegacies(accessToken)).then((resultAction) => {
        if (fetchLegacies.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      });
    }
    return () => {
      dispatch(resetLegaciesState());
    };
  }, [dispatch, accessToken, navigate]);

  const handleOpenModal = (legacy) => {
    setSelectedLegacy(legacy);
    const matchedLegacy = legaciesDataOption?.find(
      (opt) => opt?.name === legacy?.legacy_name
    );
    setUpdatedLegacy(matchedLegacy || "");
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedLegacy(null);
  };

  const handleUpdate = async () => {
    try {
      const response = await updatelegacyNameService(
        selectedAsset,
        updatedLegacy,
        accessToken
      );
      if (response?.data?.status === true) {
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: response?.data?.message,
          life: 3000,
        });
        GetLegaciesData();
        handleCloseModal();
      }
    } catch (error) {
      const status = error?.response?.status;
      handleErrorRedirect(status, navigate);
      console.error("Error adding transaction:", error);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: error.message,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
    setIsModalOpen(false);
  };

  return (
    <div className="p-6 flex items-center justify-center mt-20">
      {data && data.length > 0 ? (
        <table className="w-1/2 border-collapse text-center text-info dark:text-grey">
          <thead>
            <tr className="border-b dark:border-grey/40 border-info/40 text-lightPrimary dark:text-primary-gradient font-bold">
              <th className="py-2">Legacy</th>
              {data?.map((legacy, index) => (
                <th
                  key={index}
                  className="py-2 flex items-center justify-center gap-2"
                >
                  {legacy.legacy_name}{" "}
                  <FiEdit
                    className="text-info dark:text-grey cursor-pointer"
                    onClick={() => handleOpenModal(legacy)}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data[0]?.data?.length > 0 ? (
              data[0].data.map((_, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="py-2"></td>
                  {data.map((legacy, colIndex) => (
                    <td key={colIndex} className="py-2">
                      {legacy.data[rowIndex]?.item_name || "-"}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={data.length + 1}
                  className="py-4 text-center text-gray-500"
                >
                  No Data Available
                </td>
              </tr>
            )}

            <tr className="border-b font-bold dark:border-grey/40 border-info/40 text-lightPrimary dark:text-primary-gradient">
              <td className="py-2">Total</td>
              {data?.map((legacy, index) => (
                <td key={index} className="py-2">
                  {formatNumber(
                    truncateToTwoDecimals(
                      Number(legacy.total_initial_amount ?? 0)
                    )
                  )}{" "}
                  {currency ? currency : ""}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      ) : (
        <div className="text-center text-gray-500 text-lg">
          No Data Available
        </div>
      )}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto px-4">
          <div className="dark:bg-custom-radial bg-[#F6F6F6] rounded-lg shadow-lg p-6 text-[rgba(255,255,255,1)] md:w-1/4 w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-semibold text-lightPrimary dark:text-primary-gradient mb-4">
                Change Legacy
              </h2>
              <button
                onClick={handleCloseModal}
                className="text-lightPrimary dark:text-darkWaring focus:outline-none mt-[-46px]"
              >
                <FaTimes fontSize={20} />
              </button>
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleUpdate();
              }}
            >
              <FormDropdown
                label="Legacy Name"
                value={updatedLegacy}
                name="legacyName"
                onChange={(e) => setUpdatedLegacy(e.target.value)}
                options={legaciesDataOption || []}
                placeholder="Select Legacy"
                optionsLabel="name"
                className={`rounded-lg w-full p-0 bg-transparent border border-info dark:border-grey text-white focus:outline-none focus:border-b-2 ${
                  !updatedLegacy ? "border-red-500" : ""
                }  ${updatedLegacy ? "asset_Dropdown" : ""}`}
                containerClassName="col-span-2"
                labelClassName="block mb-2 text-lg text-info dark:text-grey font-medium"
                mainClassName="w-full mb-4"
              />
              <div className="flex justify-end gap-2">
                <FormActions
                  actionType="Update"
                  onCancel={handleCloseModal}
                  className="justify-end"
                  submitType="submit"
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default LegacyComponent;
